export const promotionConfigConstants = {
  UPDATE_FILTER_REQUEST: 'PROMOTION/UPDATE_FILTER_REQUEST',
  UPDATE_FILTER_MULTIPLE: 'PROMOTION/UPDATE_FILTER_MULTIPLE',
  RESET_FILTERS: 'PROMOTION/RESET_FILTERS',
  GET_PROMOTION_SUMMARY_REQUEST: 'PROMOTION/GET_PROMOTION_SUMMARY_REQUEST',
  GET_PROMOTION_SUMMARY_SUCCESS: 'PROMOTION/GET_PROMOTION_SUMMARY_SUCCESS',
  GET_PROMOTION_SUMMARY_ERROR: 'PROMOTION/GET_PROMOTION_SUMMARY_ERROR'
};
